import * as React from "react";
import { useIntl } from "@grandvisionhq/state";
import { formatDistance } from "@grandvisionhq/utils";
import { NearbyStores } from "./NearbyStores.js";
import { getStoreDetailUrl } from "../../../../utils/utils/store-utils.js";
const NearbyStoresContainer = ({
  stores: storeData,
  urls,
  storeDetails,
  ...rest
}) => {
  const { getLabel, distanceUnit, getFormattedLabel } = useIntl();
  const storeDetailsUrlProvider = React.useMemo(
    () => getStoreDetailUrl(urls?.storeDetails || ""),
    [urls]
  );
  const labels = React.useMemo(
    () => ({
      title: getLabel("stores.component.nearbyStores.title")
    }),
    [getLabel]
  );
  const stores = React.useMemo(() => {
    return storeData.filter(
      (store) => !storeDetails?.globalStoreId || storeDetails?.globalStoreId !== store.globalStoreId
    ).map((store) => {
      const storeDetailsUrl = storeDetailsUrlProvider(store);
      const distance = store.distance !== void 0 ? formatDistance(store.distance, distanceUnit, { separator: " " }) : store.distance;
      return {
        globalStoreId: store.globalStoreId,
        url: storeDetailsUrl,
        image: store.detailImage ?? urls?.storeFallbackImage?.url ?? "",
        label: store.shortName,
        distance: getFormattedLabel("stores.component.nearbyStores.distance", {
          labelData: { distance: distance ?? "" }
        })
      };
    });
  }, [storeData, urls, distanceUnit, storeDetailsUrlProvider, getFormattedLabel, storeDetails]);
  const links = React.useMemo(() => {
    const linksToBeAdded = [];
    if (storeDetails?.breadcrumbName && storeDetails?.breadcrumbSlug) {
      linksToBeAdded.push({
        label: getFormattedLabel("stores.component.nearbyStores.group", {
          labelData: { groupName: storeDetails.breadcrumbName }
        }),
        url: storeDetails.breadcrumbSlug
      });
    }
    if (urls?.storeOverview) {
      linksToBeAdded.push({
        label: getLabel("stores.component.nearbyStores.allStores"),
        url: urls.storeOverview
      });
    }
    return linksToBeAdded;
  }, [urls, getLabel, getFormattedLabel, storeDetails]);
  return /* @__PURE__ */ React.createElement(NearbyStores, { ...rest, labels, stores, links });
};
export {
  NearbyStoresContainer,
  NearbyStoresContainer as default
};
//# sourceMappingURL=NearbyStoresContainer.js.map
